<template>
  <div>
    <h1 class="util--screen-reader">{{ t("routes.invoices.name") }}</h1>
    <div class="content-grid">
      <InvoiceTable
          v-if="invoices"
          :invoices="invoices"
          :is-loading="invoicesAreLoading"
          :title="t('routes.invoices.name')"/>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {useI18n} from "vue3-i18n"
import {onMounted, ref} from "vue"
import {useInvoiceService} from "@/inversify.config"
import InvoiceTable from "@/components/tables/InvoiceTable.vue";
import {Invoice} from "@/types/entities";
import {ProductCategory} from "@/types/productCategory";
import {getValueForLocale} from "@/helpers";

const {t} = useI18n()

const invoiceService = useInvoiceService()

const invoices = ref<Invoice[]>([])
const invoicesAreLoading = ref(false)

onMounted(async () => {
  await loadInvoices()
})

async function loadInvoices() {
  invoicesAreLoading.value = true

  let myInvoices = await invoiceService.getMyInvoices()
  if (myInvoices) {
    myInvoices.forEach(invoice => {
      let title = invoice.productCategory == ProductCategory.MembershipPlan
          ? invoice.createdAt
          : getValueForLocale(invoice.productName)
      invoice.description = `${t(`products.${invoice.productCategory}`)} : ${title}`
    })
    invoices.value = myInvoices
  }
  invoicesAreLoading.value = false
}
</script>
